import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Usuario } from '../models/usuario';
import { Response } from '../interface/response';
import { environment } from '../../environments/environment';

@Injectable({providedIn:'root'})
export class LoginService {
    private static menuSesion: any[] = [];
    public url: string;
    public identity: Usuario = null;
    public token: string = "";
    public Mensaje: string = "";

    constructor(private _http: HttpClient) {
        this.url = environment.url;
    }

    guardaIdentity(identity: Usuario) {
        LoginService.menuSesion = identity?.menu || LoginService.menuSesion || [];
        const identityPersistida = { ...identity, menu: [] };
        localStorage.setItem('identity', JSON.stringify(identityPersistida));
        this.identity = identityPersistida as Usuario;
    }

    actualizaIdentity(identity: Usuario) {
        const identityPersistida = { ...identity, menu: [] };
        localStorage.setItem('identity', JSON.stringify(identityPersistida));
        this.identity = identityPersistida as Usuario;
    }

    getMenu() {
        return LoginService.menuSesion || [];
    }

    limpiaSesion() {
        LoginService.menuSesion = [];
        localStorage.removeItem('identity');
        localStorage.removeItem('token');
    }

    getIdentity() {
        const identityStorage = localStorage.getItem('identity');
        if (!identityStorage || identityStorage === 'undefined' || identityStorage === 'null') {
            this.identity = null;
            return this.identity;
        }

        const identity = JSON.parse(identityStorage);
        if (identity == null) {
            this.identity = null;
            return this.identity;
        }

        identity.menu = [];
        this.identity = identity;
        return this.identity;
    }

    getToken() {
        const tokenStorage = localStorage.getItem('token');
        if (!tokenStorage || tokenStorage === 'undefined' || tokenStorage === 'null') {
            this.token = "";
            return this.token;
        }

        const token = JSON.parse(tokenStorage);
        this.token = token ? "Bearer " + token : "";
        return this.token;
    }
    login(usuario:Usuario) {
        return this._http.post<Response<Usuario>>(this.url + 'Login/', usuario, { headers: new HttpHeaders().set('Content-Type', 'application/json') });
    }

    loginGoogle(credential: string, usuario: Usuario) {
        return this._http.post<Response<Usuario>>(this.url + 'Login/Google', {
            credential,
            connectionId: usuario.connectionId,
            tipoSistema: usuario.tipoSistema
        }, { headers: new HttpHeaders().set('Content-Type', 'application/json') });
    }

    ObtieneFoto(usuario:Usuario) {
        return this._http.get<Response<Usuario>>(this.url + 'Login/PorCorreo/' + usuario.correo, { headers: new HttpHeaders().set('Content-Type', 'application/json') });
    }
    CierraSesion(usuario:Usuario){
        return this._http.delete<Response<Usuario>>(this.url + 'Login/CierraSesion/' + usuario.correo + '/' + usuario.boton, { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization",this.getToken()) });
    }
}




